import { render, staticRenderFns } from "./MetricCard.vue?vue&type=template&id=072c6074&scoped=true"
import script from "./MetricCard.vue?vue&type=script&lang=js"
export * from "./MetricCard.vue?vue&type=script&lang=js"
import style0 from "./MetricCard.vue?vue&type=style&index=0&id=072c6074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c6074",
  null
  
)

export default component.exports